import { render, staticRenderFns } from "./fourPage.vue?vue&type=template&id=d0cd721e&scoped=true&"
import script from "./fourPage.vue?vue&type=script&lang=js&"
export * from "./fourPage.vue?vue&type=script&lang=js&"
import style0 from "./fourPage.vue?vue&type=style&index=0&id=d0cd721e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd721e",
  null
  
)

export default component.exports